import { render, staticRenderFns } from "./timeLimitList.vue?vue&type=template&id=37ad447c&scoped=true"
import script from "./timeLimitList.vue?vue&type=script&lang=js"
export * from "./timeLimitList.vue?vue&type=script&lang=js"
import style0 from "./timeLimitList.vue?vue&type=style&index=0&id=37ad447c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37ad447c",
  null
  
)

export default component.exports